const paginateCommon = {
	pageTo: '到第',
	pageName: '页',
	sure: '确定',
	total: '共',
	totalNum: '条'
}
export default paginateCommon